/**
 * Binary command
 */
import {CommandClause} from "../print/command_clause";

import {PsdkConst} from "../../types";
import * as iconv from 'iconv-lite';

// import {FastGBK} from "../../../toolkit";

export class BinaryCommand {
  private binary: Array<number>;

  constructor(binary?: Array<number>) {
    this.binary = binary ?? [];
  }

  public static make(): BinaryCommand {
    return new BinaryCommand();
  }

  public static with(u8a: Uint8Array): BinaryCommand {
    const b = Array.from(u8a);
    return new BinaryCommand(b)
  }

  public appendNumber(num: number): BinaryCommand {
    this.binary.push(num);
    return this;
  }

  public appendText(text: string, charset?: string): BinaryCommand {
    const encoding = (charset ?? PsdkConst.DEF_CHARSET).toLowerCase();
    const binary = iconv.encode(text, encoding);
    // const binary = FastGBK.encode(text);
    this.binary.push(...binary);
    return this;
  }

  public appendU8A(u8a: Uint8Array): BinaryCommand {
    const b = Array.from(u8a);
    this.binary = this.binary.concat(b);
    return this;
  }

  public output(): Uint8Array {
    return new Uint8Array(this.binary);
  }

  public clause(): CommandClause {
    const output = this.output();
    return CommandClause.binary(output);
  }

}
